// Filas del respaldo legacy de respuestas (answers.json). Las respuestas de un item no llevan `type`; los addons
// (fotos, comentarios, documentos, video) si.

export function isLegacyAnswerRow (row, occurrenceId, itemId) {
  return !row.type && String(row.occurrence_id) === String(occurrenceId) && Number(row.item_id) === Number(itemId)
}

export function legacyRowKey (row) {
  return JSON.stringify(row)
}

export function sameLegacyRow (a, b) {
  return legacyRowKey(a) === legacyRowKey(b)
}
